import { render, staticRenderFns } from "./PgaTextArea.vue?vue&type=template&id=aae062e4&"
import script from "./PgaTextArea.vue?vue&type=script&lang=ts&"
export * from "./PgaTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aae062e4')) {
      api.createRecord('aae062e4', component.options)
    } else {
      api.reload('aae062e4', component.options)
    }
    module.hot.accept("./PgaTextArea.vue?vue&type=template&id=aae062e4&", function () {
      api.rerender('aae062e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaTextArea.vue"
export default component.exports